import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StorageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"storage"}/>
}
